module.exports = __webpack_public_path__ + "img/meta_tag_logo_blog.fbce22ae.png";